// Widget kind a PropertyTranslator renders as. Only String is used today; the rest are declared
// up front so scene object types added later (length, area, point3d fields, ...) don't need a
// separate enum migration.
enum PropertyItemTypeEnum {
    String = "String",
    MultilineString = "MultilineString",
    Boolean = "Boolean",
    Integer = "Integer",
    Double = "Double",
    Length = "Length",
    Point3d = "Point3d",
    List = "List",
}

export default PropertyItemTypeEnum;
